<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fmtitle"><a id="page_4">CONTENTS</a></h1><a id="page_4">
</a><p class="toca"><a id="page_4"></a><a href="#/xhtml/05_AboutBook#bk"><b>ABOUT THIS BOOK</b></a></p>
<p class="toca"><a href="#/xhtml/06_AboutMe#me"><b>ABOUT ME</b></a></p>
<p class="toca"><a href="#/xhtml/07_Tips#tp"><b>MY QUICK TIPS</b></a></p>
<p class="tocc"><a href="#/xhtml/08_Chapter01#ch1"><b>SEWING ROOM ESSENTIALS</b></a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev1">My sewing room</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev2">Sewing machines</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev3">Tools</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev4">Fabrics</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev5">Fabric terminology</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev6">Wadding</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev7">Interfacing</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev8">Threads</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev9">Toy filler for softies</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev10">DIY templates</a></p>
<p class="toc1"><a href="#/xhtml/08_Chapter01#lev11">Storage</a></p>
<p class="tocc"><span href="#/xhtml/09_Chapter02#ch2" title="Link target outside of Sample"><b>SEWING KNOW-HOW</b></span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev12" title="Link target outside of Sample">Machine stitches</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev13" title="Link target outside of Sample">Seams</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev14" title="Link target outside of Sample">Cutting</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev15" title="Link target outside of Sample">Hems</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev16" title="Link target outside of Sample">PROJECT   Heart pincushion</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev17" title="Link target outside of Sample">Zips</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev18" title="Link target outside of Sample">Piping</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev19" title="Link target outside of Sample">PROJECT   Pillow cover</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev20" title="Link target outside of Sample">Shirring</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev21" title="Link target outside of Sample">Free-motion embroidery</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev22" title="Link target outside of Sample">PROJECT   Shirring dress</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev23" title="Link target outside of Sample">Bias binding</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev24" title="Link target outside of Sample">PROJECT   Toaster cover</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev25" title="Link target outside of Sample">Appliqué</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev26" title="Link target outside of Sample">PROJECT   Drawstring bag</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev27" title="Link target outside of Sample">Bag making</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev28" title="Link target outside of Sample">PROJECT   Tablet case</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev29" title="Link target outside of Sample">PROJECT   Frame purse</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev30" title="Link target outside of Sample">PROJECT   Tote bag</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev31" title="Link target outside of Sample">Pleating and pin tucks</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev32" title="Link target outside of Sample">PROJECT   Bolster pillow</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev33" title="Link target outside of Sample">Quilting</span></p>
<p class="toc2"><span href="#/xhtml/09_Chapter02#lev34" title="Link target outside of Sample">PROJECT   Machine mat</span></p>
<p class="toc1"><span href="#/xhtml/09_Chapter02#lev35" title="Link target outside of Sample">Dressmaking</span></p>
<p class="toca"><span href="#/xhtml/10_Index#ind" title="Link target outside of Sample"><b>INDEX</b></span></p>
<div class="img_container"><img alt="image" src="images/img-004.1.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?05e01c8a